
import new_tab from 'images/icon/new_tab.svg';
import phone_button from 'images/icons/company/phone_button.svg';
import * as React from 'react';
import { getTranslate, Translate } from 'react-localize-redux';
import { Collapse } from 'reactstrap';
import { useSetRecoilState } from 'recoil';
import styled from 'styled-components';
import { ITag } from '../../../../typings/proto/protobufs';
import { ACompanyEdition } from '../../../atoms/company/companyEdition';
import AddressModificator from '../../../components_v2/address/AddressModificator';
import { addressToString } from '../../../components_v2/address/function/Function';
import { Address } from '../../../components_v2/address/model/Model';
import DropdownOwners, { UserBlock } from '../../../components_v2/dropdown/DropdownOwners';
import TagsPicker from '../../../components_v2/dropdown/TagsPicker';
import { DropdownData } from '../../../components_v2/dropdown/model/Model';
import { blurOnEnterPressed } from '../../../components_v2/input/Input';
import { getTags, updateTags } from '../../../components_v2/toolbarFilter/tags/action';
import { TagType } from '../../../components_v2/toolbarFilter/tags/Model';
import storeLang from '../../../helpers/storeLang';
import { Loader } from '../../../styles/global/css/GlobalLoader';
import { HoverEmailWrapper } from '../../email-templates/emailTemplatePopup';
import { emailValid, validatePhoneNumber, validateWebsite } from '../../globals/FieldFunction';
import { LoadingStateEnum } from '../../import/model';
import { Owner } from '../../orders/model/Model';
import Restricted from '../../permissions/Restricted';
import { ModalState } from '../../products/model';
import { TitleWithOpen } from '../../products/product';
import { FlexDiv, InnerContainerTitle } from '../../products/style';
import { updateCompany } from '../data/action';
import { ClientCompanyEdit, CompanyDetail } from '../model/Model';
import { BodyMainText, BodyMainTextEditable, ButtonAction } from '../style/PopupStyle';

interface ErrorType {
	parent_company?: string
	website?: boolean
	phone?: boolean
	email?: boolean
}

const LocalCollapse = styled(Collapse) <{ justify?: string }>`
	width: inherit;
	display: flex;
	justify-content: ${p => p.justify ?? 'center'};
	&:not(.show) &:collapse {
		display: none;
	}
`;

import { CompanyDetailDisplayer, CompanyDetailDisplayerRowWrapper, CompanyDetailDisplayerWrapper, LineHoverDiv } from './DetailDisplayer';
export { CompanyDetailDisplayer, CompanyDetailDisplayerRowWrapper, CompanyDetailDisplayerWrapper, LineHoverDiv };



export const EditorWrapper = styled(LineHoverDiv)`
  display: inline-block;
  min-width: 370px;
  font-size: 13px;
  width: 30%;
  padding: 15px 15px 0px 15px;
`;

export const OptionsModal = styled(LineHoverDiv) <{ gap?: string, width?: string }>`
	display: flex;
	flex-direction: column;
	gap: ${props => props.gap ?? '20px'};
	width: ${props => props.width ?? '30%'};
	min-width: 370px;
	font-size: 13px;
	padding: 10px 20px;
`;

export function TitleAndChild(props: { children, title, overrideOpen?: boolean, defaultOpen?: boolean, titleStyle?: React.CSSProperties, localCollapseStyle?: React.CSSProperties, margin?: string, addDiv?: boolean, justify?: string }): JSX.Element {
	const [isOpen, setIsOpen] = React.useState(props.defaultOpen ?? false);

	React.useEffect(() => {
		setIsOpen(props.defaultOpen ?? false);
	}, [props.defaultOpen]);

	return <>
		<InnerContainerTitle noBorder margin={props.margin ?? '15px 30px 0 0'} style={props.titleStyle}>
			<TitleWithOpen isOpen={props.overrideOpen ?? isOpen} setIsOpen={setIsOpen} openRight openSize={11}>
				{props.title}
			</TitleWithOpen>
		</InnerContainerTitle>
		{props.addDiv && <div><LocalCollapse style={props.localCollapseStyle} isOpen={props.overrideOpen ? props.overrideOpen : isOpen} justify={props.justify}>
			{props.children}
		</LocalCollapse></div>}
		{!props.addDiv && <LocalCollapse style={props.localCollapseStyle} isOpen={props.overrideOpen ? props.overrideOpen : isOpen} justify={props.justify}>
			{props.children}
		</LocalCollapse>}
	</>;
}

function Detail(props: {
	clientCompanyId: number
	loading: LoadingStateEnum
	setLoading: (value: LoadingStateEnum) => void
	owners: Owner[]
	companyDetail: CompanyDetail | undefined
	companyInformation: CompanyDetail | undefined
	refresh: () => void
	isSelf: boolean
	isExtend: boolean,
	openSubCompany: React.Dispatch<React.SetStateAction<ModalState<number>>>
}): JSX.Element {
	const translate = getTranslate(storeLang.getState().localize);

	const [tags, setTags] = React.useState<ITag[]>([]);
	const [selectedUser, setSelectedUser] = React.useState<Owner>();

	const [isOpenBillingAddress, setOpenBillingAddress] = React.useState<boolean>(false);
	const [billingAddress, setBillingAddress] = React.useState<Address>();

	const [phone, setPhone] = React.useState<string>('');
	const [email, setEmail] = React.useState<string>('');
	const [website, setWebsite] = React.useState<string>('');

	const [companyDetail, setCompanyDetail] = React.useState<CompanyDetail>();
	const setAtomCompanyEdition = useSetRecoilState(ACompanyEdition);

	const [tagLoadingState, setTagLoadingState] = React.useState<LoadingStateEnum>(LoadingStateEnum.LOADED);
	const [error, setError] = React.useState<ErrorType>({});

	function getOwnerOptions(owners: Owner[]): DropdownData<Owner>[] {
		return owners.map(owner => {
			return {
				label: owner.name,
				value: owner,
				image: owner.photoUrl,
				selected: owner.isYou
			};
		});
	}

	function update(params: ClientCompanyEdit): void {
		updateCompany(params).then(_ => setAtomCompanyEdition(params));
	}

	function addTag(tag: ITag): void {
		if (!companyDetail) return;
		setTagLoadingState(LoadingStateEnum.LOADING);
		const params = {
			ressource_id: companyDetail.company_id,
			client_company_id: companyDetail.company_id,
			ids_add: [tag.id!]
		};
		updateTags(TagType.COMPANY, params).then(response => {
			setTagLoadingState(LoadingStateEnum.LOADED);
			if (response.valueOf()) {
				setAtomCompanyEdition(params);
				setCompanyDetail({ ...companyDetail, tags: companyDetail.tags.concat(tag) });
			}
		}).catch(_ => setTagLoadingState(LoadingStateEnum.LOADED));
	}

	function deleteTag(id: number): void {
		if (!companyDetail) return;
		const params = {
			ressource_id: companyDetail.company_id,
			client_company_id: companyDetail.company_id,
			ids_delete: [id]
		};
		updateTags(TagType.COMPANY, params).then(response => {
			if (response.valueOf()) {
				setAtomCompanyEdition(params);
				setCompanyDetail({ ...companyDetail, tags: companyDetail.tags.filter(t => t.id !== id) });
			}
		});
	}

	function updateOwner(owner: Owner): void {
		setSelectedUser(owner);
		update({
			client_company_id: props.clientCompanyId,
			owner_id: owner.id
		});
	}

	function updateBillingAddress(address: Address): void {
		setBillingAddress(address);
		update({
			client_company_id: props.clientCompanyId,
			billing_country: address.country,
			billing_city: address.town,
			billing_postcode: address.postalCode,
			billing_address: address.street,
			latitude: address.latitude,
			longitude: address.longitude
		});
	}

	function updatePhone(nphone: string): void {
		if (phone !== nphone) {
			setPhone(nphone);
			update({
				client_company_id: props.clientCompanyId,
				phone: nphone
			});
		}
	}

	function updateMail(nemail: string): void {
		if (email !== nemail) {
			setEmail(nemail);
			update({
				client_company_id: props.clientCompanyId,
				email: nemail
			});
		}
	}

	function updateWebsite(nwebsite: string): void {
		if (website != nwebsite) {
			setWebsite(nwebsite);
			update({
				client_company_id: props.clientCompanyId,
				website: nwebsite
			});
		}
	}

	React.useEffect(() => {
		if (tags.length <= 0) {
			getTags(TagType.COMPANY).then(res => {
				const detail: CompanyDetail = {
					...props.companyDetail!,
					tags: props.companyDetail?.tag_ids.map(id => res.find(t => t.id === id)!) ?? []
				};
				setTags(res);

				setCompanyDetail(detail);
				if (detail.company_billing_country || detail.company_billing_post_code || detail.company_billing_address || detail.company_billing_city) {
					setBillingAddress({
						country: detail.company_billing_country,
						postalCode: detail.company_billing_post_code,
						street: detail.company_billing_address,
						town: detail.company_billing_city
					} as Address);
				}
				setPhone(detail.company_phone);
				setWebsite(detail.company_website);
				setEmail(detail.company_email);
				setError({ ...error, phone: !validatePhoneNumber(detail.company_phone ?? ''), website: !validateWebsite(detail.company_website ?? ''), email: !emailValid(detail.company_email ?? '') });
				setSelectedUser(props.owners.find(u => u.id === props.companyDetail?.owner_id));
				props.setLoading(LoadingStateEnum.LOADED);
			});
		} else {
			const detail: CompanyDetail = {
				...props.companyDetail!,
				tags: props.companyDetail!.tag_ids.map(id => tags.find(t => t.id === id)!)
			};
			setCompanyDetail(detail);
		}
	}, [props.companyDetail]);

	if (props.loading === LoadingStateEnum.LOADING) {
		return (
			<Loader center width="40px" />
		);
	}

	return <FlexDiv flow="column" width='100%' padding='15px 0 0 0'>
		{(companyDetail != null) &&
			<Restricted
				to={{ objectAction: 'UpdateCompany' }}
				isSelf={props.isSelf}
				fallback={<TagsPicker readOnly paddingLeft='10px' tags={tags} selected={companyDetail.tags.filter(t => t)} />}
			>
				<TagsPicker
					paddingLeft='10px'
					tags={tags}
					selected={companyDetail.tags.filter(t => t)}
					loading={tagLoadingState === LoadingStateEnum.LOADING}
					onAdd={addTag}
					onDelete={deleteTag}
				/>
			</Restricted>
		}
		<TitleAndChild title={<Translate id='overview' />} defaultOpen>
			<CompanyDetailDisplayerWrapper>
				<CompanyDetailDisplayer title={<Translate id='owner' />}>
					<Restricted
						to={{ objectAction: 'UpdateCompany' }}
						isSelf={props.isSelf}
						fallback={<UserBlock user={selectedUser} />}
					>
						<DropdownOwners
							dropdownStyle={{ optionWidth: '175px', optionHeight: '150px', width: '100%' }}
							users={getOwnerOptions(props.owners)}
							selected={{ label: selectedUser?.name ?? '', value: selectedUser, image: selectedUser?.photoUrl }}
							onChange={(value: DropdownData) => updateOwner(value.value)}
							open
						/>
					</Restricted>
				</CompanyDetailDisplayer>
				<CompanyDetailDisplayer title={<Translate id='company.columns.company_address' />}>
					<FlexDiv height='25px'>
						<Restricted
							to={{ objectAction: 'UpdateCompany' }}
							isSelf={props.isSelf}
							fallback={<BodyMainText height='fit-content' marginLeft='0' minHeight='unset' display='block'>{addressToString(billingAddress ?? undefined, true)}</BodyMainText>}
						>
							<BodyMainText height='fit-content' marginLeft='0' minHeight='unset' display='block' cursor="pointer" onClick={() => setOpenBillingAddress(true)}>{addressToString(billingAddress ?? undefined, true)}</BodyMainText>
						</Restricted>
						<Restricted
							to={{ objectAction: 'ViewMap' }}
							isSelf={props.isSelf}
						>
							<>
								{billingAddress !== undefined && <ButtonAction parent={CompanyDetailDisplayerRowWrapper} width="20px" src={new_tab} alt="billing address" onClick={() => window.open(`/map?company=${companyDetail?.company_id}`, '_blank')} />}
							</>
						</Restricted>
					</FlexDiv>
				</CompanyDetailDisplayer>
				<CompanyDetailDisplayer title={<Translate id='phone' />}>
					<FlexDiv height='25px'>
						<Restricted
							to={{ objectAction: 'UpdateCompany' }}
							isSelf={props.isSelf}
							fallback={<BodyMainText height='fit-content' marginLeft='0' minHeight='unset' display='block'>{phone}</BodyMainText>}
						>
							<BodyMainTextEditable
								height='fit-content'
								marginLeft='0'
								minHeight='unset'
								width='100%'
								suppressContentEditableWarning
								contentEditable
								error={error.phone}
								onInput={e => {
									if (validatePhoneNumber(e.currentTarget.innerText.trim())) {
										setError({ ...error, phone: false });
									} else {
										setError({ ...error, phone: true });
									}
								}}

								onKeyDownCapture={blurOnEnterPressed}
								onBlur={(e) => {
									const newPhone = e.currentTarget.innerText.trim().replaceAll(' ', '');
									if (validatePhoneNumber(newPhone)) {
										updatePhone(newPhone);
										setPhone(newPhone);
									} else {
										setError({ ...error, phone: true });
									}
								}}
							>
								{phone}
							</BodyMainTextEditable>
						</Restricted>
						{phone && <ButtonAction parent={CompanyDetailDisplayerRowWrapper} src={phone_button} alt="phone" onClick={() => window.open(`tel:${phone}`)} />}
					</FlexDiv>
				</CompanyDetailDisplayer>
				<CompanyDetailDisplayer title={<Translate id='website' />}>
					<FlexDiv height='25px'>
						<Restricted
							to={{ objectAction: 'UpdateCompany' }}
							isSelf={props.isSelf}
							fallback={<BodyMainText height='fit-content' marginLeft='0' minHeight='unset' display='block'>{website}</BodyMainText>}
						>
							<BodyMainTextEditable
								height='fit-content'
								marginLeft='0'
								minHeight='unset'
								width='100%'
								error={error.website}
								suppressContentEditableWarning
								onInput={e => {
									if (validateWebsite(e.currentTarget.innerText.trim())) {
										setError({ ...error, website: false });
									} else {
										setError({ ...error, website: true });
									}
								}}
								contentEditable
								onKeyDownCapture={blurOnEnterPressed}
								onBlur={(e) => {
									const newWebsite = e.currentTarget.innerText.trim();
									if (validateWebsite(newWebsite)) {
										updateWebsite(newWebsite);
										setWebsite(newWebsite);
									} else {
										setError({ ...error, website: true });
									}
								}}
							>
								{website}
							</BodyMainTextEditable>
						</Restricted>
						{
							website && website.length > 0 &&
							<ButtonAction parent={CompanyDetailDisplayerRowWrapper} src={new_tab} alt="link" onClick={() => {
								if (website) {
									const web = website.startsWith('http') ? website : `https://${website}`;
									window.open(web, '_blank');
								}
							}} />
						}
					</FlexDiv>
				</CompanyDetailDisplayer>
				<CompanyDetailDisplayer title={<Translate id='email' />}>
					<FlexDiv height='25px'>
						<Restricted
							to={{ objectAction: 'UpdateCompany' }}
							isSelf={props.isSelf}
							fallback={<BodyMainText height='fit-content' marginLeft='0' minHeight='unset' display='block'>{email}</BodyMainText>}
						>
							<BodyMainTextEditable
								height='fit-content'
								marginLeft='0'
								minHeight='unset'
								width='100%'
								error={error.email}
								onInput={e => {
									if (emailValid(e.currentTarget.innerText.trim())) {
										setError({ ...error, email: false });
									} else {
										setError({ ...error, email: true });
									}
								}}
								suppressContentEditableWarning
								contentEditable
								onKeyDownCapture={blurOnEnterPressed}
								onBlur={(e) => {
									const newEmail = e.currentTarget.innerText.trim();
									if (emailValid(newEmail)) {
										updateMail(newEmail);
										setEmail(newEmail);
									} else {
										setError({ ...error, email: true });
									}
								}}
							>
								{email}
							</BodyMainTextEditable>
						</Restricted>
						{email && companyDetail &&
							<HoverEmailWrapper parent={CompanyDetailDisplayerRowWrapper} emailTemplateVariable={{
								first_name: companyDetail.owner_name.split(' ')[0] ?? '',
								last_name: companyDetail.owner_name.split(' ')[1] ?? '',
								company_name: companyDetail.company_name ?? ''
							}} email={email} />
						}
					</FlexDiv>
				</CompanyDetailDisplayer>

			</CompanyDetailDisplayerWrapper>
		</TitleAndChild>
		<AddressModificator
			isOpen={isOpenBillingAddress}
			setOpen={setOpenBillingAddress}
			defaultAddress={billingAddress}
			onChange={(na) => updateBillingAddress(na)}
			title={translate('company.columns.company_address').toString()}
		/>
	</FlexDiv>;
}

export default Detail;
